import React, { useState, useEffect } from 'react'
import LoadingSpinner from '../components/LoadingSpinner'

const OfficialDocs = () => {
  const [htmlContent, setHtmlContent] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchHtmlContent = async () => {
      try {
        const response = await fetch('/api/docs/homepage-widgets')
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const content = await response.text()
        setHtmlContent(content)
      } catch (err) {
        console.error('获取HTML内容失败:', err)
        setError(err.message)
      } finally {
        setIsLoading(false)
      }
    }

    fetchHtmlContent()
  }, [])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-6">
          <h2 className="text-xl font-bold text-red-400 mb-2">加载文档失败</h2>
          <p className="text-red-300">错误信息: {error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-full p-1">
      {/* 渲染HTML内容 */}
      <div 
        className="bg-gray-800 rounded border border-gray-700 overflow-hidden w-full"
        style={{ height: 'calc(100vh - 80px)' }}
      >
        <iframe
          srcDoc={htmlContent}
          className="w-full h-full border-none"
          style={{ height: '100%' }}
          sandbox="allow-same-origin allow-scripts"
          title="Homepage 官方配置文档"
        />
      </div>

    </div>
  )
}

export default OfficialDocs
